import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    projectSettings: string;
    projectName: string;
    defaultProjectName: string;
    editAvatar: string;
    cancel: string;
    save: string;
    dialogCloseLabel: string;
    accessSectionTitle: string;
    storageSectionTitle: string;
    moveProject: {
        /** Title for the confirm dialog when moving a project to standard storage */
        title: string;
        /** Confirm button label for the move project dialog */
        buttonText: string;
        /** Confirmation word the user must type to proceed */
        confirmationWord: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Dialog title for project settings */
            projectSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.projectSettings?c=wzo5pyetchj6", defaultMessage: "Project settings" }));
                },
                enumerable: true,
                configurable: true
            },
            /* Aria label for project name settings */
            projectName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.projectName?c=3k1itetfyvwcr", defaultMessage: "Project Name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Fallback project name when none is set */
            defaultProjectName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.defaultProjectName?c=3lwyyx94sr8g7", defaultMessage: "Untitled Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the avatar editor action */
            editAvatar: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.editAvatar?c=m32wpmcnpvan", defaultMessage: "Edit project avatar" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Secondary action label to cancel edits */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Primary action label to save changes */
            save: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.save?c=1oof7q3mpz3f9", defaultMessage: "Save" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the dialog close button */
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Section title for project access and policy settings */
            accessSectionTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.accessSectionTitle?c=2d4vyx9rfa3pj", defaultMessage: "Access" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Section title for project storage settings */
            storageSectionTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.storageSectionTitle?c=1sao7shjzhwoe", defaultMessage: "Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            moveProject: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for the confirm dialog when moving a project to standard storage */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.moveProject.title?c=2syo4y1cw6uog", defaultMessage: "Move Project to Standard Storage" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Confirm button label for the move project dialog */
                        buttonText: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.moveProject.buttonText?c=se6x0lvlyt3", defaultMessage: "Move Project" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Confirmation word the user must type to proceed */
                        confirmationWord: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSettingsModal.moveProject.confirmationWord?c=3jk3x44h13pm5", defaultMessage: "move" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
